import React, { Component } from "react";
import { Button, Card } from "react-bootstrap";
import { Image, Col, Container, Row } from "react-bootstrap";

import ProjectCard from "./ProjectCard";
import ProjectDetails from "./ProjectDetails";

const images = require.context("../../public/static/images", true);
const projects = require.context("../../public/static/data", true);

const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return string;
};

class Projects extends Component {
  style = { paddingTop: 30, paddingBottom: 30 };

  componentDidMount() {
    console.log(new Date(), " Work is mouned 🙃");
  }

  componentWillUnmount() {
    console.log(new Date(), " Work will be killed 😭");
  }

  render() {
    return (
      <div>
        <Container style={this.style}>
          <Row style={this.style}>
            <h1>Projects</h1>
          </Row>
          <Row style={{ marginTop: 10, marginBottom: 10 }}>
            {this.props.data.projects.map((project) => {
              return (
                <Col xs={6} md={4} key={project.key}>
                  <ProjectCard
                    title={project.title}
                    bodyText={project.shortDescription}
                    hashTags={project.hashTags}
                    popupContent={
                      <ProjectDetails
                        projectTitle={project.title}
                        projectDescription={
                          isValidHttpUrl(project.description)
                            ? project.description
                            : projects(`./${project.description}`).default
                        }
                        videoUrl={project.videoUrl}
                      />
                    }
                    imageUrl={
                      isValidHttpUrl(project.imageUrl)
                        ? project.imageUrl
                        : images(`./${project.imageUrl}`).default
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
    );
  }
}

export default Projects;
